var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatMapViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.00004V14C0 14.5303 0.21077 15.0391 0.585767 15.4142C0.960932 15.7892 1.46969 16 2.00004 16H14C14.5303 16 15.0391 15.7892 15.4142 15.4142C15.7892 15.0391 16 14.5303 16 14V2.00004C16 1.46969 15.7892 0.960936 15.4142 0.585767C15.0391 0.21077 14.5303 0 14 0H2.00004C1.46969 0 0.960936 0.21077 0.585767 0.585767C0.21077 0.960932 0 1.46969 0 2.00004ZM5.00011 14.9998H2.00013C1.73495 14.9998 1.48049 14.8945 1.29299 14.707C1.10549 14.5195 1.00019 14.2651 1.00019 13.9999V12.9999H5.00011V14.9998ZM5.00011 11.9998H1.00019V9.99996H5.00011V11.9998ZM5.00011 8.99985H1.00019V6.99998H5.00011V8.99985ZM10.0002 11.9998H6.00013V9.99996H10L10.0002 11.9998ZM10.0002 5.99987H6.00013V4H10L10.0002 5.99987ZM14.0001 14.9998H11.0002V12.9999H15.0001V13.9999C15.0001 14.265 14.8948 14.5195 14.7073 14.707C14.5198 14.8945 14.2653 14.9998 14.0001 14.9998ZM15.0001 11.9998H11.0002V9.99996H15.0001V11.9998ZM15.0001 8.99985H11.0002V6.99998H15.0001V8.99985ZM15.0001 2.99989H11.0002V1.00002H14.0001C14.2653 1.00002 14.5198 1.10532 14.7073 1.29282C14.8948 1.48032 15.0001 1.73476 15.0001 1.99996V2.99989Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMapViewIcon);
export default __webpack_public_path__ + "static/media/heatMapViewIcon.e1b4657d493517184390f8c42cbe4703.svg";
export { ForwardRef as ReactComponent };